import { render, staticRenderFns } from "./UploadGlosasForm.vue?vue&type=template&id=2bf0b47a&scoped=true"
import script from "./UploadGlosasForm.vue?vue&type=script&lang=js"
export * from "./UploadGlosasForm.vue?vue&type=script&lang=js"
import style0 from "./UploadGlosasForm.vue?vue&type=style&index=0&id=2bf0b47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0b47a",
  null
  
)

export default component.exports